import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';

export const PrivacyPage = () => {
  return (
    <div className="pt-24 pb-16" data-testid="privacy-page">
      <div className="max-w-4xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="mb-8"
        >
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-white/60 hover:text-white transition-colors mb-8"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to Home
          </Link>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          className="glass-card p-8 md:p-12"
        >
          <h1 className="text-3xl md:text-4xl font-bold mb-2">Privacy Policy</h1>
          <p className="text-white/50 mb-8">Last updated: January 2024</p>

          <div className="prose prose-invert max-w-none">
            <div className="space-y-8 text-white/70">
              <section>
                <h2 className="text-xl font-semibold text-white mb-4">1. Information We Collect</h2>
                <p>
                  We collect information you provide directly to us, including name, email address, company 
                  information, and any other information you choose to provide. We also collect usage data 
                  and information about how you interact with our services.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white mb-4">2. How We Use Your Information</h2>
                <p>We use the information we collect to:</p>
                <ul className="list-disc list-inside mt-2 space-y-2">
                  <li>Provide, maintain, and improve our services</li>
                  <li>Process transactions and send related information</li>
                  <li>Send technical notices, updates, and support messages</li>
                  <li>Respond to your comments, questions, and requests</li>
                  <li>Analyze usage patterns and improve user experience</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white mb-4">3. Data Security</h2>
                <p>
                  We implement appropriate technical and organizational measures to protect your personal 
                  data against unauthorized access, alteration, disclosure, or destruction. This includes 
                  AES-256 encryption for data at rest and TLS encryption for data in transit.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white mb-4">4. Data Retention</h2>
                <p>
                  We retain your personal data for as long as your account is active or as needed to provide 
                  you services. If you cancel your subscription, your data will be available for 30 days 
                  after which it will be securely deleted.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white mb-4">5. Information Sharing</h2>
                <p>
                  We do not sell, trade, or rent your personal information to third parties. We may share 
                  information with service providers who assist in our operations, subject to confidentiality 
                  agreements.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white mb-4">6. Your Rights</h2>
                <p>You have the right to:</p>
                <ul className="list-disc list-inside mt-2 space-y-2">
                  <li>Access your personal data</li>
                  <li>Correct inaccurate data</li>
                  <li>Request deletion of your data</li>
                  <li>Export your data in a portable format</li>
                  <li>Opt-out of marketing communications</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white mb-4">7. Cookies</h2>
                <p>
                  We use cookies and similar tracking technologies to track activity on our service and hold 
                  certain information. You can instruct your browser to refuse all cookies or to indicate 
                  when a cookie is being sent.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white mb-4">8. Changes to This Policy</h2>
                <p>
                  We may update our Privacy Policy from time to time. We will notify you of any changes by 
                  posting the new Privacy Policy on this page and updating the "Last updated" date.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white mb-4">9. Contact Us</h2>
                <p>
                  If you have any questions about this Privacy Policy, please contact us at:{' '}
                  <a href="mailto:info@costgenie.com" className="text-[#00D4FF] hover:underline">
                    info@costgenie.com
                  </a>
                </p>
              </section>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default PrivacyPage;
